import { Redirect, useLocalSearchParams } from "expo-router";

import {
  normalizeDemoRoute,
  resolveWeHonorSpecRoute,
} from "../data/wehonor-spec-routes";
import {
  CENTRAL_APP_URL,
  isRetiredMonarchStaffDemoPath,
} from "../../../lib/hosting-contract";
import WeHonorSystemWorkspaceScreen from "./WeHonorSystemWorkspaceScreen";

export default function DemoMonarchSpecRouteScreen({
  fixedPath,
}: {
  fixedPath?: string | readonly string[];
}) {
  const params = useLocalSearchParams<{ path?: string | string[] }>();
  const requestedPath = fixedPath ?? params.path;
  const route = normalizeDemoRoute(requestedPath);

  if (isRetiredMonarchStaffDemoPath(route)) {
    return <Redirect href={CENTRAL_APP_URL} />;
  }

  const resolved = resolveWeHonorSpecRoute(requestedPath);

  return (
    <WeHonorSystemWorkspaceScreen
      screenIdOverride={resolved.screenId}
      routeOverride={resolved.route}
    />
  );
}
